export const BOARD_SIZE = 7;
export const INITIAL_TIME = 90;
export const STONES_PER_PLAYER = 4; 
